import React from 'react';

import UserIcon from "../../../../../../core/gd-components/icons/user/user-icon-deprecated";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import FieldProto from "../../../../proto/field-proto";
import PopoverMenuOption from "../../../../../gd-components/popover-menu/popover-menu/menu-option";
import PopoverMenuOptionWithCustomPopover
    from "../../../../../gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover";

type Props = {
    field               : FieldProto
    option              : Option
    isHighlighted       : boolean
    isSelected          : boolean
    currentOption       : Option    // Current selected option
    highlightedOption   : Option    // Current highlighted option

    onClick             : callback
}

type State = {
    showPopover: boolean
}

export default class FieldUserAndDeleted_PopoverOption extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover : false
        }
    }

    togglePopover = ()=> {
        this.setState({showPopover: !this.state.showPopover})
    }

    onClick = () => {
        if (!!this.props.option.menuComponent) {
            this.togglePopover()
        } else {
            this.props.onClick(this.props.option)
        }
    }

    render() {

        const classes = Classes("deleted-users-option", "option", "with-icon-26", {
            "highlighted"   : this.props.isHighlighted,
            "selected"      : this.props.isSelected
        })

        const iconClass = Classes("ico", this.props.option.icon)

        return (
            <div className={classes} onClick={this.onClick}>

                {this.props.option.icon && <div className={iconClass}/>}

                {!this.props.option.icon &&
                    <>
                        {!this.props.option.value && <div className="ico i5-users"/>}
                        {this.props.option.value &&
                            <div className="ico">
                                <UserIcon userId={this.props.option.value} hint={false} size="26"/>
                            </div>}
                    </>}

                <div className="label">
                    {this.props.option.label}
                </div>

                {this.props.option.menuComponent && (
                    <>
                        <div className="submenu-arrow i5-big-angle-right"></div>

                        {this.state.showPopover && (
                            <Popover position                 = {PopoverPosition.right("-12 0")}
                                     className                = "cursor-default border-box"
                                     outsideClickIgnoreClass  = "option">

                                {this.props.option.menuComponent(this.props.field, this.props.onClick, this.props.currentOption, this.props.highlightedOption)}

                            </Popover>
                        )}
                    </>
                )}

            </div>
        )
    }
}
